import Layout from "./Layout.jsx";
import LoginForm from "../components/auth/LoginForm.jsx";
import ProtectedRoute from "../components/auth/ProtectedRoute.jsx";

import Dashboard from "./Dashboard";

import Applications from "./Applications";

import AgentProfile from "./AgentProfile";

import Documents from "./Documents";

import Commissions from "./Commissions";

import Training from "./Training";

import AgentRegistration from "./AgentRegistration";

import AgentDashboard from "./AgentDashboard";

import UniversityDashboard from "./UniversityDashboard";

import Agents from "./Agents";

import UniversityCommissions from "./UniversityCommissions";

import UniversityApplications from "./UniversityApplications";

import MyProfile from "./MyProfile";

import MyApplications from "./MyApplications";

import MyCommissions from "./MyCommissions";

import Documentation from "./Documentation";

import Analytics from "./Analytics";

import AgentDetail from "./AgentDetail";

import ApplicationDetail from "./ApplicationDetail.jsx";

import SuperAdminDashboard from "./SuperAdminDashboard.jsx";

import UniversityManagement from "./UniversityManagement.jsx";

import InvitationAccept from "./InvitationAccept.jsx";

import AuditLogs from "./AuditLogs.jsx";

import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

const PAGES = {
    
    Dashboard: Dashboard,
    
    Applications: Applications,
    
    AgentProfile: AgentProfile,
    
    Documents: Documents,
    
    Commissions: Commissions,
    
    Training: Training,
    
    AgentRegistration: AgentRegistration,
    
    AgentDashboard: AgentDashboard,
    
    UniversityDashboard: UniversityDashboard,
    
    Agents: Agents,
    
    UniversityCommissions: UniversityCommissions,
    
    UniversityApplications: UniversityApplications,
    
    MyProfile: MyProfile,
    
    MyApplications: MyApplications,
    
    MyCommissions: MyCommissions,
    
    Documentation: Documentation,
    
    Analytics: Analytics,
    
    AgentDetail: AgentDetail,
    
    ApplicationDetail: ApplicationDetail,
    
    SuperAdminDashboard: SuperAdminDashboard,
    
    UniversityManagement: UniversityManagement,
    
    InvitationAccept: InvitationAccept,
    
    AuditLogs: AuditLogs,
    
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <Routes>            
                {/* Public routes */}
                <Route path="/login" element={<LoginForm />} />
                <Route path="/accept-invitation" element={<InvitationAccept />} />
                
                {/* Protected routes */}
                <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/Dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                
                {/* Super Admin routes */}
                <Route path="/SuperAdminDashboard" element={<ProtectedRoute><SuperAdminDashboard /></ProtectedRoute>} />
                <Route path="/UniversityManagement" element={<ProtectedRoute><UniversityManagement /></ProtectedRoute>} />
                
                {/* University Admin routes */}
                <Route path="/UniversityDashboard" element={<ProtectedRoute><UniversityDashboard /></ProtectedRoute>} />
                <Route path="/Agents" element={<ProtectedRoute><Agents /></ProtectedRoute>} />
                <Route path="/UniversityCommissions" element={<ProtectedRoute><UniversityCommissions /></ProtectedRoute>} />
                <Route path="/UniversityApplications" element={<ProtectedRoute><UniversityApplications /></ProtectedRoute>} />
                <Route path="/Analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                <Route path="/AuditLogs" element={<ProtectedRoute><AuditLogs /></ProtectedRoute>} />
                
                {/* Agent routes */}
                <Route path="/AgentDashboard" element={<ProtectedRoute><AgentDashboard /></ProtectedRoute>} />
                <Route path="/Applications" element={<ProtectedRoute><Applications /></ProtectedRoute>} />
                <Route path="/MyApplications" element={<ProtectedRoute><MyApplications /></ProtectedRoute>} />
                <Route path="/MyCommissions" element={<ProtectedRoute><MyCommissions /></ProtectedRoute>} />
                <Route path="/AgentProfile" element={<ProtectedRoute><AgentProfile /></ProtectedRoute>} />
                <Route path="/MyProfile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
                
                {/* Shared routes */}
                <Route path="/Documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
                <Route path="/Training" element={<ProtectedRoute><Training /></ProtectedRoute>} />
                <Route path="/Documentation" element={<ProtectedRoute><Documentation /></ProtectedRoute>} />
                
                {/* Detail pages */}
                <Route path="/AgentDetail" element={<ProtectedRoute><AgentDetail /></ProtectedRoute>} />
                <Route path="/ApplicationDetail" element={<ProtectedRoute><ApplicationDetail /></ProtectedRoute>} />
                
                {/* Legacy route for agent registration */}
                <Route path="/AgentRegistration" element={<ProtectedRoute><AgentRegistration /></ProtectedRoute>} />
            </Routes>
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}